module.exports = __webpack_public_path__ + "resources/img/img_skyhigh_security_en.a9771cae2fddcd9eca19a275e775f838.png";